import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MarketingNav, BackToTop } from '../components/ui/MarketingNav';
import { SiteFooter } from './AboutPage';

const PROMISE = [
  {
    n: '01',
    t: 'Răspundem repede.',
    d: 'În aceeași zi, de obicei în aceeași oră. Dacă e weekend și ne ești mire sau nașă cu o urgență, ne mișcăm și mai repede.',
  },
  {
    n: '02',
    t: 'Răspunde un om, nu un bot.',
    d: 'Noi, cu numele nostru real, nu cu „Echipa GuestLens". Ne place să știm cu cine vorbim, ne place și ca tu să știi cu cine vorbești.',
  },
  {
    n: '03',
    t: 'Fără ofertă-standard.',
    d: 'Ne scrii ce ai pe suflet — buget, dată, ce-ți place, ce-ți displace. Îți răspundem exact pe situația ta, nu cu un copy-paste.',
  },
];

export default function ContactPage() {
  return (
    <div className="min-h-screen">
      <MarketingNav />

      {/* ─── Hero ─── */}
      <section className="container-page relative pb-3xl pt-lg">
        <div className="mx-auto max-w-3xl text-center">
          <p className="kicker justify-center">Contact</p>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mt-sm font-serif"
            style={{
              fontSize: 'clamp(2.4rem, 5vw, 4.2rem)',
              lineHeight: 1.2,
              fontVariationSettings: "'opsz' 144, 'SOFT' 100, 'WONK' 1",
            }}
          >
            Scrie-ne un email.
            <br />
            Îți răspundem cu drag.
          </motion.h1>

          <p className="mt-lg text-lg text-fg-soft">
            Fără formulare, fără câmpuri obligatorii, fără „un coleg te va
            contacta". Un singur click și ne ajunge direct în inbox —
            telefon, laptop, tot.
          </p>

          <div className="mt-xl">
            <a
              href="mailto:guestlens.events@gmail.com?subject=Salut%20de%20la%20un%20eveniment"
              className="btn-primary"
            >
              guestlens.events@gmail.com
            </a>
          </div>

          <p className="mt-md font-mono text-[0.7rem] uppercase tracking-[0.18em] text-fg-soft">
            sau pur și simplu apasă butonul de mai sus
          </p>
        </div>
      </section>

      {/* ─── Pull quote ─── */}
      <section className="border-y border-border bg-bg-alt py-3xl">
        <div className="container-page">
          <blockquote className="mx-auto max-w-3xl text-center">
            <p
              className="font-serif italic"
              style={{
                fontSize: 'clamp(1.6rem, 2.6vw, 2.4rem)',
                lineHeight: 1.3,
              }}
            >
              „Dacă ne scrii la 11 noaptea că ți-e frică
              <br />
              că n-ai ales bine pentru nuntă,
              <br />
              îți răspundem la 11 și 7 minute."
            </p>
            <p className="mt-md font-mono text-xs uppercase tracking-[0.2em] text-fg-soft">
              — promisiune reală, nu de marketing
            </p>
          </blockquote>
        </div>
      </section>

      {/* ─── Three promises ─── */}
      <section className="container-page py-4xl">
        <div className="mx-auto max-w-3xl text-center">
          <p className="kicker justify-center">Ce promitem</p>
          <h2 className="mt-sm" style={{ fontVariationSettings: "'opsz' 144" }}>
            Trei lucruri
            <br />
            <em className="italic text-fg-soft">pe care le poți conta</em>.
          </h2>
        </div>

        <div className="mt-2xl grid grid-cols-1 gap-2xl md:grid-cols-3">
          {PROMISE.map((p) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
            >
              <p className="font-mono text-sm text-accent">— {p.n}</p>
              <h3
                className="mt-sm font-serif text-2xl"
                style={{ fontVariationSettings: "'opsz' 144" }}
              >
                {p.t}
              </h3>
              <p className="mt-md text-fg-soft">{p.d}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ─── Big repeat CTA ─── */}
      <section className="bg-bg-alt py-4xl">
        <div className="container-page">
          <div className="mx-auto max-w-2xl text-center">
            <p className="kicker justify-center">Încă citești?</p>
            <h2 className="mt-sm" style={{ fontVariationSettings: "'opsz' 144" }}>
              Hai să-ți scrii
              <br />
              <em className="italic text-fg-soft">pe un drum scurt</em>.
            </h2>
            <p className="mt-md text-fg-soft">
              Pune-ne o întrebare, cere o ofertă, sau spune-ne „am văzut
              un demo și am vrut să zic că mi-a plăcut". Toate trei
              contează.
            </p>
            <div className="mt-xl flex flex-wrap justify-center gap-sm">
              <a
                href="mailto:guestlens.events@gmail.com"
                className="btn-primary"
              >
                Trimite-ne un email
              </a>
              <Link to="/intrebari-frecvente" className="btn-ghost">
                Citește FAQ-ul →
              </Link>
            </div>
          </div>
        </div>
      </section>

      <SiteFooter />
      <BackToTop />
    </div>
  );
}
